import { createTheme } from '@mui/material';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#2563eb' },
    background: { default: '#0a141d', paper: '#0b1c30' },
    divider: '#1e2e46',
    text: { primary: '#d9e3f1', secondary: '#c3c6d7' },
    error: { main: '#ef4444' },
    warning: { main: '#f59e0b' }
  },
  typography: { fontFamily: 'Inter, sans-serif' },
});

export const DAYS_OF_WEEK = [
  { id: 'Monday', labelKey: 'schoolShiftPage.days.monday' },
  { id: 'Tuesday', labelKey: 'schoolShiftPage.days.tuesday' },
  { id: 'Wednesday', labelKey: 'schoolShiftPage.days.wednesday' },
  { id: 'Thursday', labelKey: 'schoolShiftPage.days.thursday' },
  { id: 'Friday', labelKey: 'schoolShiftPage.days.friday' },
  { id: 'Saturday', labelKey: 'schoolShiftPage.days.saturday' },
  { id: 'Sunday', labelKey: 'schoolShiftPage.days.sunday' },
];